import { useEffect, useRef, useState } from 'react';

const events = [
	'keydown',
	'mousemove',
	'touchmove',
	'click',
	'scroll',
	'wheel'
];

export const useIdle = (timeout: number) => {
	const [idle, setIdle] = useState(false);
	const timer = useRef(-1);

	useEffect(() => {
		const handleEvents = () => {
			setIdle(false);

			if (timer.current) {
				clearTimeout(timer.current);
			}

			timer.current = window.setTimeout(() => {
				setIdle(true);
			}, timeout);
		};

		events.forEach(e => document.addEventListener(e, handleEvents));

		timer.current = window.setTimeout(() => {
			setIdle(true);
		}, timeout);

		return () => {
			events.forEach(e => document.removeEventListener(e, handleEvents));
			clearTimeout(timer.current);
			timer.current = -1;
		};
	}, [timeout]);

	return idle;
};
